import { render, staticRenderFns } from "./ElementsSpace.vue?vue&type=template&id=e3ff97bc"
import script from "./ElementsSpace.vue?vue&type=script&lang=js"
export * from "./ElementsSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports